import { useMemo } from 'react';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ConnectButton as LibConnectButton } from '@rainbow-me/rainbowkit';
import { useUpMedia } from '../../hooks';
// import { useSession } from '../../contexts';
import { useRefAndEarnVisibleStore } from '../../services/store';
import { resetButtonStyles } from '../../styles/helpers.ts';
// import { ModeMenu } from '../menus';
import { DesktopButton } from './DesktopButton.tsx';
import { MobileButton } from './MobileButton.tsx';

const ConnectButton = () => {
  const { t } = useTranslation();
  /*const { isAuthenticated,
    // signingInWithWallet,
    // signInWithWallet
  } =
    useSession();*/

  const toggleReferAndEarnOverflow = useRefAndEarnVisibleStore(
    ({ toggle }) => toggle
  );

  const desktop = useUpMedia('md');

  const {
    Button,
    // LoginButton,
    InfoButton,
  } = useMemo(
    () =>
      desktop
        ? ({
            Button: DesktopButton,
            LoginButton: DesktopLoginButton,
            InfoButton: DesktopInfoButton,
          } as const)
        : ({
            Button: CommonMobileButton,
            LoginButton: MobileLoginButton,
            InfoButton: MobileInfoButton,
          } as const),
    [desktop]
  );

  return (
    <LibConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        mounted,
      }) => {
        const connected = mounted && account && chain;

        if (!mounted) return null;

        if (!connected) {
          return (
            <Button onClick={openConnectModal}>
              {t('CONNECT_BUTTON__connect')}
            </Button>
          );
        }

        if (chain.unsupported) {
          return (
            <Button onClick={openChainModal}>
              {t('CONNECT_BUTTON__wrongNetwork')}
            </Button>
          );
        }

        return (
          <ButtonsWrapper>
            {/* <ModeMenu>
              <InfoButton>{t('CONNECT_BUTTON__mode')}</InfoButton>
            </ModeMenu> */}
            {/* {isAuthenticated ? (
              <>
                {isNumber(userBalance) && (
                  <HeaderUserBalance
                    type={currencyType}
                    balance={userBalance}
                  />
                )}
              </>
            ) : (
              <> */}
            {/* \@ts-expect-error strange ts mismatch */}
            {/* <LoginButton
                  loading={signingInWithWallet}
                  onClick={signInWithWallet}
                >
                  {t('CONNECT_BUTTON__login')}
                </LoginButton>
              </>
            )} */}
            <InfoButton onClick={toggleReferAndEarnOverflow}>
              🤑{' '}
              <span
                style={{
                  marginLeft: 2,
                }}
              >
                {t('CONNECT_BUTTON__earn')}
              </span>
            </InfoButton>
            <InfoButton onClick={openAccountModal}>
              {account.displayName}
              {/*{!isAuthenticated && account.displayBalance
                ? ` (${account.displayBalance})`
                : ''}*/}
            </InfoButton>
          </ButtonsWrapper>
        );
      }}
    </LibConnectButton.Custom>
  );
};

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;

  ${({ theme }) => theme.getUpMedia('md')} {
    gap: ${({ theme }) => theme.responsive(20)};
  }
`;

const CommonMobileButton = styled(MobileButton).attrs({
  size: 'small',
})``;

const MobileLoginButton = styled(CommonMobileButton)``;

const MobileInfoButton = styled.button.attrs({
  type: 'button',
})`
  ${resetButtonStyles};
  padding: 4px;
  background-color: ${({ theme }) => theme.getColor('ebonyClay')};
  border-radius: 30px;
  font-size: 10px;
`;

const CommonDesktopButton = styled(DesktopButton)`
  padding-left: ${({ theme }) => theme.responsive(20)};
  padding-right: ${({ theme }) => theme.responsive(20)};
`;

const DesktopLoginButton = styled(CommonDesktopButton)``;

const DesktopInfoButton = styled.button.attrs({
  type: 'button',
})`
  ${resetButtonStyles};
  padding: ${({ theme }) => theme.spacing(10, 16)};
  background-color: ${({ theme }) => theme.getColor('ebonyClay')};
  border-radius: ${({ theme }) => theme.responsive(30)};
  font-size: ${({ theme }) => theme.responsive(16)};
`;

export { ConnectButton };
